var map = {
	"./cremation-vs-burial-australia.json": [
		759,
		[
			759
		]
	],
	"./direct-cremation-australia.json": [
		6689,
		[
			6689
		]
	],
	"./diy-or-professional-tribute-video.json": [
		1730,
		[
			1730
		]
	],
	"./funeral-celebrant-vs-religious-ceremony.json": [
		8069,
		[
			8069
		]
	],
	"./funeral-cost-australia.json": [
		5398,
		[
			5398
		]
	],
	"./funeral-insurance-vs-prepaid-funeral-vs-funeral-bond.json": [
		8192,
		[
			8192
		]
	],
	"./funeral-memorial-video-technical-checklist.json": [
		4699,
		[
			4699
		]
	],
	"./funeral-order-of-service-template.json": [
		2025,
		[
			2025
		]
	],
	"./funeral-readings-and-poems.json": [
		7884,
		[
			7884
		]
	],
	"./funeral-slideshow-songs.json": [
		9727,
		[
			9727
		]
	],
	"./funeral-slideshow-vs-memorial-video.json": [
		5635,
		[
			5635
		]
	],
	"./grief-support-australia.json": [
		6532,
		[
			6532
		]
	],
	"./how-many-photos-funeral-slideshow.json": [
		1929,
		[
			1929
		]
	],
	"./how-to-choose-a-funeral-director.json": [
		3523,
		[
			3523
		]
	],
	"./how-to-pay-for-a-funeral-australia.json": [
		7560,
		[
			7560
		]
	],
	"./how-to-plan-a-funeral-australia.json": [
		5273,
		[
			5273
		]
	],
	"./how-to-register-a-death-australia.json": [
		4294,
		[
			4294
		]
	],
	"./how-to-write-a-eulogy.json": [
		1878,
		[
			1878
		]
	],
	"./how-to-write-an-obituary-australia.json": [
		5971,
		[
			5971
		]
	],
	"./memorial-funeral-video-guide.json": [
		4761,
		[
			4761
		]
	],
	"./memorial-ideas.json": [
		921,
		[
			921
		]
	],
	"./memorial-video-few-photos.json": [
		2029,
		[
			2029
		]
	],
	"./memorial-video-ideas.json": [
		9339,
		[
			9339
		]
	],
	"./prepare-material-for-memorial-video.json": [
		3082,
		[
			3082
		]
	],
	"./secular-funeral-ideas-australia.json": [
		909,
		[
			909
		]
	],
	"./superannuation-funeral-costs.json": [
		7569,
		[
			7569
		]
	],
	"./what-happens-to-memorial-video-after-funeral.json": [
		9148,
		[
			9148
		]
	],
	"./what-to-do-when-someone-dies-australia.json": [
		6565,
		[
			6565
		]
	],
	"./what-to-include-in-a-memorial-video.json": [
		8306,
		[
			8306
		]
	],
	"./who-to-notify-when-someone-dies.json": [
		1988,
		[
			1988
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 8791;
module.exports = webpackAsyncContext;